import { assert } from '../../lib/assert-sidecar'
import { common } from '../../main/common-sidecar'
import { EVoyageCarryableType } from './voyageCarryable'
import { voyageCarryable } from './voyageCarryable-sidecar'
import type { IVoyageCrew } from './voyageCrew'
import { voyageTilemap } from './voyageTilemap-sidecar'

export function onEnter(obj: IVoyageCrew) {
  let ds = common.getUpdateDeltaScaled()
  let d = obj.crewState
  assert.notNil(d)

  let tHere = voyageTilemap.getSafeIJ(obj)
  console.log('1')
  if (tHere) {
    let sys = tHere.system
    console.log('2')
    if (sys) {
      console.log('3', sys.ammo)
      if (!obj.carryable) {
        console.log('4')
        if (sys.ammo > 0) {
          obj.carryable = voyageCarryable.create(
            EVoyageCarryableType.BattleRifle,
          )
          voyageCarryable.moveToXY(obj.carryable, obj.x, obj.y)
          sys.ammo--
        }
      } else if (
        obj.carryable &&
        obj.carryable.type === EVoyageCarryableType.BattleRifle
      ) {
        sys.ammo++
        voyageCarryable.kill(obj.carryable)
        obj.carryable = null
      }
    }
  }
}
